import styled from 'styled-components';
import * as symbol from '../../../assets/symbols/symbols/Symbols.css';
import {BGImageCenter, DEFAULT_COLOR, desktopMedia, mobileMedia, STRONG_BLUE} from '../../../globalVariables/GlobalVariables';
import {alignCenter, dFlex, dFlexBetween, dFlexColumn, flexRow} from '../../../globalVariables/GlobalFlex';

interface MenuProps {
  $selected?: boolean;
  $icon?: string;
  $open?: boolean;
  deliveryTypesLength?:number;
  $disabled?: boolean;
}

export const MenuContainer= styled.div`
  width: 100%;
  font-weight: 600;
  ${desktopMedia}{
      padding: 20px;
      max-width: 280px;
      margin: 0 auto;
      margin-top: 70px;
  }
`;

export const MenuList= styled.div`
    ${dFlexColumn}
    gap: 11px;
    ${mobileMedia} {
      ${flexRow};
      max-width: 100vw;
      overflow-x: auto;
      gap:0;
    }
`;

export const DropdownItem= styled.div<MenuProps>`
    ${dFlexBetween}
    padding: 15px ${p => p.$selected ? 17 : 20}px 15px 20px;
    width: 129px;
    min-width: max-content;
    height: 28px;
    border-inline-start: ${p => p.$selected ? 3 : 0}px solid ${DEFAULT_COLOR};
    border-radius: 24px 0px 0px 24px;
    background-color: ${p=>p.$selected ? `${STRONG_BLUE}26` : 'transparent'};
    transition: all 0.1s ease;
    cursor: pointer;
    &>svg{
        width: 20px;
        height: 20px;
        margin-inline-end: 13px;
    }
    ${mobileMedia} {
          border-radius: 24px;
          border-inline-start: none;
          padding: 4px 10px;
          svg.chevron {     
            margin-inline: 6px;
            width: 7px;
            height: 8px;
          }
    }
    &::after{
        content: '';
        display: inline-block;
        width: ${p=>p.$selected && p.$open ?8:0}px;
        transition: all 0.1s ease;
        height: 10px;
        ${BGImageCenter(symbol.arrowDown, 'contain')};
        margin-inline-start: 10px;
        ${mobileMedia} {
          width: 0;
        }
    }
  `;

export const subMenu = styled.div<MenuProps>`
  height: ${p => p.$selected ? p.deliveryTypesLength * 24 + (p.deliveryTypesLength - 1) * 24  : 0}px;
  transition: all 0.2s ease;
  ${dFlexColumn};
  gap: 24px;
  font-size: 12px;
  overflow: hidden;
  margin-top: 14px;
  ${mobileMedia} {
    height: 0;
  }
`;

export const MenuItem= styled.div<MenuProps>`
    ${dFlex}
    ${alignCenter}
    padding: 0px ${p => p.$selected ? 17 : 20}px 0px 20px;
    cursor: ${p => p.$disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.1s ease;
    border-inline-start: ${p => p.$selected ? 3 : 0}px solid ${DEFAULT_COLOR};
    opacity: ${p => p.$disabled ? 0.5 : 1};
    &::before{
        content: '';
        display: inline-block;
        width: ${p=>p.$icon ? 15 : 0}px;
        height: 15px;
        ${p=>BGImageCenter(symbol[p.$icon], '15px')};
    }
  `;

export const MenuText= styled.span`
    margin-inline-start: 13px;;
    font-size: 12px;
  `;

export const EmailIcon= styled.div`
    width: 24px;
    height: 24px;
  `;
